import { motion } from "framer-motion";
import { Send, MessageCircle } from "lucide-react";
import { FadeIn, EASE } from "./Reveal";

export default function JoinButtons() {
  return (
    <section
      id="join"
      data-testid="community-cta-section"
      className="border-b border-[#e2e8f0] bg-[#f8fafc]"
    >
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
        <FadeIn>
          <p
            data-testid="community-cta-text"
            className="max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg"
          >
            Join our partner community — we provide ready-made creatives,
            videos, and daily marketing kits so you can share with your
            students and audience without any extra effort.
          </p>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div className="mt-8 grid max-w-3xl gap-4 sm:grid-cols-2">
            <motion.a
              href="https://t.me/edualertpartner"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-telegram-button"
              className="btn-lift group flex items-center justify-between gap-3 rounded-2xl bg-[#0088cc] px-6 py-5 text-base font-bold text-white shadow-xl shadow-[#0088cc]/25 hover:bg-[#0077b3] sm:text-lg"
              whileHover={{ scale: 1.015 }}
              transition={{ duration: 0.3, ease: EASE }}
            >
              <span className="flex items-center gap-3">
                <Send className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-1" />
                Join Our Telegram Channel
              </span>
              <span className="font-mono-edu text-xs opacity-60">↗</span>
            </motion.a>
            <motion.a
              href="https://whatsapp.com/channel/0029VbD2TVSAjPXOMi5Mpn2f"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-button"
              className="btn-lift group flex items-center justify-between gap-3 rounded-2xl bg-[#1faa53] px-6 py-5 text-base font-bold text-white shadow-xl shadow-[#25d366]/25 hover:bg-[#189348] sm:text-lg"
              whileHover={{ scale: 1.015 }}
              transition={{ duration: 0.3, ease: EASE }}
            >
              <span className="flex items-center gap-3">
                <MessageCircle className="h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
                Join Our WhatsApp Channel
              </span>
              <span className="font-mono-edu text-xs opacity-60">↗</span>
            </motion.a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}